/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { FormDesignContainer as FormDesign } from './FormDesign.container';
